export default __webpack_public_path__ + "static/media/ic_arrow_down.50769fd7.svg";